var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPurpleTickIcon = function SvgPurpleTickIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#E0D3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.528 6.255a.87.87 0 0 0-1.23 0L8.733 10.82 6.484 8.573a.87.87 0 1 0-1.23 1.23l3.478 3.477 5.796-5.796a.87.87 0 0 0 0-1.23Z",
    fill: "#4202A8"
  })));
};
export default SvgPurpleTickIcon;